import styles from "./styles.module.scss";

interface IFeature {
  icon: string;
  label: string;
  value?: string | number;
}

interface FeaturesProps {
  items: IFeature[];
}

const Features = (props: FeaturesProps) => {
  return (
    <div className={styles.features}>
      {props.items.map((item, index) => (
        <div key={index} className={styles.featuresItem}>
          <img src={item.icon} alt={item.label} />
          <div className={styles.text}>
            <p>{item.value ?? "Неизвестно"}</p>
            <span>{item.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Features;
